// Shared utilities and types
export const SHARED_VALUE = "Hello from Shared Package!";

export interface SharedUser {
  id: string;
  name: string;
}

// Design tokens - single source of truth for web + mobile
export { default as theme } from "./theme";

// Export individual design token categories for granular imports
export {
  colors,
  spacing,
  typography,
  borderRadius,
  shadows,
  animation,
} from "./theme";
